(function () {
  'use strict';

  const MOBILE_BP = 786;

  function initStackWithThumb() {
    const galleries = document.querySelectorAll('media-gallery[data-desktop-layout="stack_with_thumb"]');
    galleries.forEach((gallery) => new StackWithThumb(gallery));
  }

  class StackWithThumb {
    constructor(gallery) {
      this.gallery = gallery;
      this.sectionId = gallery.id.replace('MediaGallery-', '');
      this.thumbStrip = gallery.querySelector('.stack-thumb-strip');
      this.thumbItems = gallery.querySelectorAll('.stack-thumb-strip__item');
      this.mediaList = gallery.querySelector('.product__media-list');
      this.mediaItems = gallery.querySelectorAll('.product__media-item');
      this.zoomEl = document.querySelector(`#StackThumbZoom-${this.sectionId}`);
      this.currentIndex = 0;
      this.mediaData = [];

      if (!this.thumbStrip || !this.mediaList) return;

      this.buildMediaData();
      this.bindThumbnails();
      this.bindImageClicks();
      this.bindZoom();
      this.initInlineZoom();
      this.setupMobileNav();
      this.setupDesktopScrollSpy();
      this.onResize();
      window.addEventListener('resize', this.onResize.bind(this));
    }

    buildMediaData() {
      this.mediaItems.forEach((item) => {
        const img = item.querySelector('.product__media img');
        if (img) {
          const highRes = img.currentSrc || img.src;
          const srcset = img.getAttribute('srcset') || '';
          let bestSrc = highRes;
          if (srcset) {
            const parts = srcset.split(',').map(s => s.trim());
            const last = parts[parts.length - 1];
            if (last) bestSrc = last.split(' ')[0];
          }
          this.mediaData.push({
            src: bestSrc,
            alt: img.alt || '',
            mediaId: item.dataset.mediaId,
          });
        } else {
          this.mediaData.push({
            src: '',
            alt: '',
            mediaId: item.dataset.mediaId,
          });
        }
      });
    }

    isMobile() {
      return window.innerWidth <= MOBILE_BP;
    }

    /* --- Thumbnails --- */
    bindThumbnails() {
      this.thumbItems.forEach((thumb, i) => {
        thumb.querySelector('button').addEventListener('click', () => {
          this.goTo(i);
        });
      });
    }

    setActiveThumb(index) {
      this.thumbItems.forEach((t) => t.classList.remove('is-active'));
      if (this.thumbItems[index]) {
        this.thumbItems[index].classList.add('is-active');
        this.thumbItems[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }

    goTo(index) {
      this.currentIndex = index;
      this.setActiveThumb(index);

      if (this.isMobile()) {
        const target = this.mediaItems[index];
        if (target) {
          this.mediaList.scrollTo({ left: target.offsetLeft - this.mediaList.offsetLeft, behavior: 'smooth' });
        }
        this.updateMobileCounter();
      } else {
        const target = this.mediaItems[index];
        if (target) {
          const stickyHeader = document.querySelector('sticky-header');
          const headerOffset = stickyHeader ? stickyHeader.offsetHeight + 20 : 20;
          const top = target.getBoundingClientRect().top + window.scrollY - headerOffset;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }
    }

    /* --- Desktop scroll spy --- */
    setupDesktopScrollSpy() {
      if (typeof IntersectionObserver === 'undefined') return;

      this.scrollObserver = new IntersectionObserver(
        (entries) => {
          if (this.isMobile()) return;
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const idx = Array.from(this.mediaItems).indexOf(entry.target);
              if (idx !== -1) {
                this.currentIndex = idx;
                this.setActiveThumb(idx);
              }
            }
          });
        },
        { threshold: 0.5 }
      );

      this.mediaItems.forEach((item) => this.scrollObserver.observe(item));
    }

    /* --- Image click → zoom --- */
    bindImageClicks() {
      this.mediaItems.forEach((item, i) => {
        const opener = item.querySelector('.product__modal-opener--image');
        if (!opener) return;

        opener.removeAttribute('data-modal');

        opener.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          this.openZoom(i);
        }, true);

        const toggle = item.querySelector('.product__media-toggle');
        if (toggle) {
          toggle.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            this.openZoom(i);
          }, true);
        }
      });
    }

    /* --- Zoom popup --- */
    bindZoom() {
      if (!this.zoomEl) return;

      this.zoomImg = this.zoomEl.querySelector('.stack-thumb-zoom__img');
      this.zoomWrap = this.zoomEl.querySelector('.stack-thumb-zoom__img-wrap');
      this.zoomClose = this.zoomEl.querySelector('.stack-thumb-zoom__close');
      this.zoomPrev = this.zoomEl.querySelector('.stack-thumb-zoom__prev');
      this.zoomNext = this.zoomEl.querySelector('.stack-thumb-zoom__next');
      this.zoomOverlay = this.zoomEl.querySelector('.stack-thumb-zoom__overlay');
      this.zoomCounter = this.zoomEl.querySelector('.stack-thumb-zoom__current');

      this.zoomClose.addEventListener('click', () => this.closeZoom());
      this.zoomOverlay.addEventListener('click', () => this.closeZoom());
      this.zoomPrev.addEventListener('click', () => this.zoomNavigate(-1));
      this.zoomNext.addEventListener('click', () => this.zoomNavigate(1));

      document.addEventListener('keydown', (e) => {
        if (this.zoomEl.getAttribute('aria-hidden') !== 'false') return;
        if (e.key === 'Escape') this.closeZoom();
        if (e.key === 'ArrowLeft') this.zoomNavigate(-1);
        if (e.key === 'ArrowRight') this.zoomNavigate(1);
      });

      this.initPinchZoom();
      this.initMouseZoom();
    }

    openZoom(index) {
      this.zoomIndex = index;
      this.loadZoomImage(index);
      this.zoomEl.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      this.resetZoomTransform();
      this.showZoomHint();
    }

    showZoomHint() {
      const hint = this.zoomEl.querySelector('.stack-thumb-zoom__hint');
      if (!hint) return;
      hint.classList.remove('is-hidden');
      clearTimeout(this.hintTimer);
      this.hintTimer = setTimeout(() => hint.classList.add('is-hidden'), 3000);
    }

    hideZoomHint() {
      const hint = this.zoomEl.querySelector('.stack-thumb-zoom__hint');
      if (hint) hint.classList.add('is-hidden');
      clearTimeout(this.hintTimer);
    }

    closeZoom() {
      this.zoomEl.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      this.resetZoomTransform();
    }

    zoomNavigate(dir) {
      this.zoomIndex = (this.zoomIndex + dir + this.mediaData.length) % this.mediaData.length;
      this.loadZoomImage(this.zoomIndex);
      this.resetZoomTransform();
    }

    loadZoomImage(index) {
      const data = this.mediaData[index];
      if (!data || !data.src) return;
      this.zoomImg.src = data.src;
      this.zoomImg.alt = data.alt;
      if (this.zoomCounter) {
        this.zoomCounter.textContent = index + 1;
      }
    }

    /* --- Inline hover zoom on product images (desktop) --- */
    initInlineZoom() {
      if (this.isMobile()) return;

      this.mediaItems.forEach((item) => {
        const opener = item.querySelector('.product__modal-opener--image');
        const mediaWrap = item.querySelector('.product__media');
        const img = mediaWrap?.querySelector('img');
        if (!opener || !mediaWrap || !img) return;

        opener.addEventListener('mouseenter', () => {
          if (this.isMobile()) return;
          img.classList.add('is-inline-zoomed');
        });

        opener.addEventListener('mousemove', (e) => {
          if (this.isMobile() || !img.classList.contains('is-inline-zoomed')) return;
          const rect = mediaWrap.getBoundingClientRect();
          const x = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
          const y = Math.max(0, Math.min(100, ((e.clientY - rect.top) / rect.height) * 100));
          img.style.transformOrigin = `${x}% ${y}%`;
        });

        opener.addEventListener('mouseleave', () => {
          img.classList.remove('is-inline-zoomed');
          img.style.transformOrigin = '';
        });
      });
    }

    /* --- Mouse double-click zoom (desktop) --- */
    initMouseZoom() {
      if (!this.zoomWrap) return;

      this.scale = 1;
      this.panX = 0;
      this.panY = 0;
      this.isDragging = false;

      this.zoomImg.addEventListener('dblclick', (e) => {
        e.preventDefault();
        this.hideZoomHint();
        if (this.scale > 1) {
          this.resetZoomTransform();
        } else {
          const rect = this.zoomWrap.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          this.scale = 2.5;
          this.panX = (rect.width / 2 - x) * (this.scale - 1) / this.scale;
          this.panY = (rect.height / 2 - y) * (this.scale - 1) / this.scale;
          this.applyZoomTransform();
          this.zoomImg.classList.add('is-zoomed');
        }
      });

      this.zoomWrap.addEventListener('mousedown', (e) => {
        if (this.scale <= 1) return;
        e.preventDefault();
        this.isDragging = true;
        this.dragStartX = e.clientX - this.panX;
        this.dragStartY = e.clientY - this.panY;
        this.zoomImg.classList.add('is-dragging');
      });

      window.addEventListener('mousemove', (e) => {
        if (!this.isDragging) return;
        this.panX = e.clientX - this.dragStartX;
        this.panY = e.clientY - this.dragStartY;
        this.applyZoomTransform();
      });

      window.addEventListener('mouseup', () => {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.zoomImg.classList.remove('is-dragging');
      });
    }

    /* --- Pinch zoom (touch) --- */
    initPinchZoom() {
      if (!this.zoomWrap) return;

      this.touchScale = 1;
      this.touchPanX = 0;
      this.touchPanY = 0;
      this.lastTouchDist = 0;
      this.lastTouchCenter = null;
      this.activeTouches = [];

      this.zoomWrap.addEventListener('touchstart', (e) => {
        this.activeTouches = Array.from(e.touches);

        if (e.touches.length === 2) {
          e.preventDefault();
          this.hideZoomHint();
          this.lastTouchDist = this.getTouchDist(e.touches);
          this.lastTouchCenter = this.getTouchCenter(e.touches);
        } else if (e.touches.length === 1 && this.scale > 1) {
          e.preventDefault();
          this.dragStartX = e.touches[0].clientX - this.panX;
          this.dragStartY = e.touches[0].clientY - this.panY;
        }
      }, { passive: false });

      this.zoomWrap.addEventListener('touchmove', (e) => {
        if (e.touches.length === 2) {
          e.preventDefault();
          const dist = this.getTouchDist(e.touches);
          const center = this.getTouchCenter(e.touches);
          const scaleDelta = dist / this.lastTouchDist;
          this.scale = Math.min(5, Math.max(1, this.scale * scaleDelta));
          this.lastTouchDist = dist;

          if (this.lastTouchCenter) {
            this.panX += (center.x - this.lastTouchCenter.x);
            this.panY += (center.y - this.lastTouchCenter.y);
          }
          this.lastTouchCenter = center;
          this.applyZoomTransform();

          if (this.scale > 1) {
            this.zoomImg.classList.add('is-zoomed');
          }
        } else if (e.touches.length === 1 && this.scale > 1) {
          e.preventDefault();
          this.panX = e.touches[0].clientX - this.dragStartX;
          this.panY = e.touches[0].clientY - this.dragStartY;
          this.applyZoomTransform();
        }
      }, { passive: false });

      this.zoomWrap.addEventListener('touchend', (e) => {
        if (e.touches.length < 2) {
          this.lastTouchDist = 0;
          this.lastTouchCenter = null;
        }
        if (e.touches.length === 0 && this.scale <= 1.05) {
          this.resetZoomTransform();
        }
        if (e.touches.length === 1 && this.scale > 1) {
          this.dragStartX = e.touches[0].clientX - this.panX;
          this.dragStartY = e.touches[0].clientY - this.panY;
        }
      });
    }

    getTouchDist(touches) {
      const dx = touches[0].clientX - touches[1].clientX;
      const dy = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    getTouchCenter(touches) {
      return {
        x: (touches[0].clientX + touches[1].clientX) / 2,
        y: (touches[0].clientY + touches[1].clientY) / 2,
      };
    }

    clampPan() {
      const wrapRect = this.zoomWrap.getBoundingClientRect();
      const imgW = this.zoomImg.naturalWidth || this.zoomImg.offsetWidth;
      const imgH = this.zoomImg.naturalHeight || this.zoomImg.offsetHeight;
      const displayedW = this.zoomImg.offsetWidth;
      const displayedH = this.zoomImg.offsetHeight;
      const scaledW = displayedW * this.scale;
      const scaledH = displayedH * this.scale;
      const maxPanX = Math.max(0, (scaledW - wrapRect.width) / 2);
      const maxPanY = Math.max(0, (scaledH - wrapRect.height) / 2);
      this.panX = Math.min(maxPanX, Math.max(-maxPanX, this.panX));
      this.panY = Math.min(maxPanY, Math.max(-maxPanY, this.panY));
    }

    applyZoomTransform() {
      this.clampPan();
      this.zoomImg.style.transform = `translate(${this.panX}px, ${this.panY}px) scale(${this.scale})`;
    }

    resetZoomTransform() {
      this.scale = 1;
      this.panX = 0;
      this.panY = 0;
      this.zoomImg.style.transform = '';
      this.zoomImg.classList.remove('is-zoomed', 'is-dragging');
    }

    /* --- Mobile slider nav --- */
    setupMobileNav() {
      const nav = document.createElement('div');
      nav.className = 'stack-mobile-nav';
      nav.innerHTML = `
        <button class="stack-mobile-nav__btn stack-mobile-nav__btn--prev" type="button" aria-label="Previous">
          <span class="svg-wrapper"><svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5"/></svg></span>
        </button>
        <span class="stack-mobile-nav__counter">
          <span class="stack-mobile-nav__current">1</span> / <span class="stack-mobile-nav__total">${this.mediaItems.length}</span>
        </span>
        <button class="stack-mobile-nav__btn stack-mobile-nav__btn--next" type="button" aria-label="Next">
          <span class="svg-wrapper"><svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5"/></svg></span>
        </button>
      `;

      this.gallery.querySelector('.slider-mobile-gutter').after(nav);

      this.mobileNavCurrent = nav.querySelector('.stack-mobile-nav__current');

      nav.querySelector('.stack-mobile-nav__btn--prev').addEventListener('click', () => {
        const newIdx = Math.max(0, this.currentIndex - 1);
        this.goTo(newIdx);
      });

      nav.querySelector('.stack-mobile-nav__btn--next').addEventListener('click', () => {
        const newIdx = Math.min(this.mediaItems.length - 1, this.currentIndex + 1);
        this.goTo(newIdx);
      });

      this.setupMobileScrollSnap();
    }

    setupMobileScrollSnap() {
      let scrollTimeout;
      this.mediaList.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          if (!this.isMobile()) return;
          const scrollLeft = this.mediaList.scrollLeft;
          const itemWidth = this.mediaItems[0]?.offsetWidth || 1;
          const idx = Math.round(scrollLeft / itemWidth);
          if (idx !== this.currentIndex && idx >= 0 && idx < this.mediaItems.length) {
            this.currentIndex = idx;
            this.setActiveThumb(idx);
            this.updateMobileCounter();
          }
        }, 100);
      });
    }

    updateMobileCounter() {
      if (this.mobileNavCurrent) {
        this.mobileNavCurrent.textContent = this.currentIndex + 1;
      }
    }

    onResize() {
      if (this.isMobile()) {
        this.mediaList.style.scrollSnapType = 'x mandatory';
      } else {
        this.mediaList.style.scrollSnapType = 'none';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStackWithThumb);
  } else {
    initStackWithThumb();
  }

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initStackWithThumb);
  }
})();
